*,
*::before,
*::after {
    box-sizing: border-box;
}

:host {
    position: relative;
    max-width: 400px;
    opacity: 0;
    transform: translateX(100%);
    --background-color: var(--color-background);
    --text-color: var(--color-text);
}

:host([dark]:not([high-contrast])) {
    --background-color: var(--color-contrast);
    --text-color: var(--color-background);
}

:host(.error) {
    --weak-color: var(--color-error-alt);
    --strong-color: var(--color-error);
}

:host(.warning) {
    --weak-color: var(--color-warning-alt);
    --strong-color: var(--color-warning);
}

:host(.info) {
    --weak-color: var(--color-info-alt);
    --strong-color: var(--color-info);
}

:host(.success) {
    --weak-color: var(--color-success-alt);
    --strong-color: var(--color-success);
}

:host([high-contrast]) {
    --weak-color: var(--background-color);
}

:host([high-contrast]) .inner {
        border: 2px solid var(--strong-color);
        border-right: 0;
    }

:host(.clickable) {
    cursor: pointer;
}

:host(.mounting) {
    opacity: 0;
    transform: translateX(100%);
}

:host(.mounted) {
    transition: all 500ms ease;
    opacity: 1;
    transform: translateX(0%);
    max-height: 90px;
}

:host(.unmounting) {
    transition: all 500ms ease;
    opacity: 0;
    transform: translateX(100%);
    max-height: 0;
}

.inner {
    display: flex;
    flex-direction: row;
    background-color: var(--background-color);
    color: var(--text-color);
    box-shadow: rgba(0, 0, 0, 0.05) 1px 1px 5px 5px;
    margin-bottom: 12px;
    padding-left: 10px;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    overflow: hidden;
    position: relative;
    z-index: 0;
}

.inner:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 10px;
        margin: auto;
        height: 40px;
        width: 40px;
        background-color: var(--weak-color);
        border: 2px solid var(--strong-color);
        border-radius: 20px;
        z-index: -1;
    }

.content {
    display: flex;
    flex-direction: column;
    padding: 12px;
}

.icon_holder {
    border-radius: 50%;
    display: flex;
    width: 40px;
    flex: 0 0 40px;
    align-items: center;
    justify-content: center;
    color: var(--strong-color);
}

::slotted(strong) {
    color: var(--strong-color);
}

es-counter {
    --text-color: var(--strong-color);
}
